export default __webpack_public_path__ + "static/logisticPlus-7d14132965eeaf25975ba59a6707a8f8.webp";